/** Usage page strings (user menu → Usage), merged into the app's translation namespace on import. */
import i18n from '@/app/i18n'

const en = {
    'usage.menu': 'Usage',
    'usage.title': 'System usage',
    'usage.description': 'Who uses the system, when and for how long, by user and by view.',
    'usage.hint': 'Active time counts only while the page is in front and in use; 5 minutes without input pauses it.',
    'usage.period': 'Period',
    'usage.days': '{{count}} days',
    'usage.tenant': 'Client',
    'usage.allTenants': 'All clients',
    'usage.staff': 'Show DistribuAI accounts',
    'usage.kpi.activeUsers': 'Active users',
    'usage.kpi.ofUsers': 'of {{total}}',
    'usage.kpi.activeTime': 'Active time',
    'usage.kpi.visits': 'Page visits',
    'usage.kpi.logins': 'Sign-ins',
    'usage.tabs': 'Breakdown',
    'usage.tab.users': 'Users',
    'usage.tab.views': 'Views',
    'usage.col.user': 'User',
    'usage.col.email': 'E-mail',
    'usage.col.role': 'Role',
    'usage.col.lastLogin': 'Last sign-in',
    'usage.col.lastSeen': 'Last active',
    'usage.col.logins': 'Sign-ins',
    'usage.col.activeDays': 'Active days',
    'usage.col.activeTime': 'Active time',
    'usage.col.visits': 'Visits',
    'usage.col.topView': 'Most used view',
    'usage.col.view': 'View',
    'usage.col.users': 'Users',
    'usage.col.avgVisit': 'Average visit',
    'usage.col.lastUsed': 'Last used',
    'usage.col.when': 'When',
    'usage.col.duration': 'Active time',
    'usage.col.device': 'Device',
    'usage.role.SUPERADMIN': 'Superadmin',
    'usage.role.TENANTADMIN': 'Admin',
    'usage.staffBadge': 'DistribuAI',
    'usage.disabled': 'Disabled',
    'usage.never': 'Never',
    'usage.detail.summary': 'Sign-ins {{logins}} · active days {{days}} · active time {{time}}',
    'usage.detail.views': 'Views',
    'usage.detail.recentVisits': 'Recent visits',
    'usage.detail.recentLogins': 'Recent sign-ins',
    'usage.detail.empty': 'No activity in this period.',
    'usage.close': 'Close',
    'usage.empty.users': 'No users.',
    'usage.empty.views': 'No visits in this period.',
    'usage.loading': 'Loading…',
    'usage.loadFailed': 'The usage data could not be loaded.',
    'usage.retry': 'Try again',
    'usage.sortAsc': 'Ascending',
    'usage.sortDesc': 'Descending',
    'usage.columnMenu': '{{header}} column menu',
    'usage.dur.s': '{{s}} s',
    'usage.dur.m': '{{m}} min',
    'usage.dur.h': '{{h}} h',
    'usage.dur.hm': '{{h}} h {{m}} min',
}

const et: typeof en = {
    'usage.menu': 'Kasutus',
    'usage.title': 'Süsteemi kasutus',
    'usage.description': 'Kes süsteemi kasutab, millal ja kui kaua – kasutajate ja vaadete kaupa.',
    'usage.hint': 'Aktiivne aeg loeb ainult siis, kui leht on ees ja kasutusel; 5 minutit tegevuseta peatab loenduse.',
    'usage.period': 'Periood',
    'usage.days': '{{count}} päeva',
    'usage.tenant': 'Klient',
    'usage.allTenants': 'Kõik kliendid',
    'usage.staff': 'Näita DistribuAI kontosid',
    'usage.kpi.activeUsers': 'Aktiivsed kasutajad',
    'usage.kpi.ofUsers': 'kokku {{total}}',
    'usage.kpi.activeTime': 'Aktiivne aeg',
    'usage.kpi.visits': 'Vaatamisi',
    'usage.kpi.logins': 'Sisselogimisi',
    'usage.tabs': 'Jaotus',
    'usage.tab.users': 'Kasutajad',
    'usage.tab.views': 'Vaated',
    'usage.col.user': 'Kasutaja',
    'usage.col.email': 'E-post',
    'usage.col.role': 'Roll',
    'usage.col.lastLogin': 'Viimati sisse loginud',
    'usage.col.lastSeen': 'Viimati aktiivne',
    'usage.col.logins': 'Sisselogimisi',
    'usage.col.activeDays': 'Aktiivseid päevi',
    'usage.col.activeTime': 'Aktiivne aeg',
    'usage.col.visits': 'Vaatamisi',
    'usage.col.topView': 'Enim kasutatud vaade',
    'usage.col.view': 'Vaade',
    'usage.col.users': 'Kasutajaid',
    'usage.col.avgVisit': 'Keskmiselt',
    'usage.col.lastUsed': 'Viimati kasutatud',
    'usage.col.when': 'Aeg',
    'usage.col.duration': 'Aktiivne aeg',
    'usage.col.device': 'Seade',
    'usage.role.SUPERADMIN': 'Superadmin',
    'usage.role.TENANTADMIN': 'Administraator',
    'usage.staffBadge': 'DistribuAI',
    'usage.disabled': 'Keelatud',
    'usage.never': 'Mitte kunagi',
    'usage.detail.summary': 'Sisselogimisi {{logins}} · aktiivseid päevi {{days}} · aktiivne aeg {{time}}',
    'usage.detail.views': 'Vaated',
    'usage.detail.recentVisits': 'Viimased vaatamised',
    'usage.detail.recentLogins': 'Viimased sisselogimised',
    'usage.detail.empty': 'Selles perioodis tegevust pole.',
    'usage.close': 'Sulge',
    'usage.empty.users': 'Kasutajaid pole.',
    'usage.empty.views': 'Selles perioodis vaatamisi pole.',
    'usage.loading': 'Laadin…',
    'usage.loadFailed': 'Kasutuse andmeid ei õnnestunud laadida.',
    'usage.retry': 'Proovi uuesti',
    'usage.sortAsc': 'Kasvav',
    'usage.sortDesc': 'Kahanev',
    'usage.columnMenu': 'Veeru {{header}} menüü',
    'usage.dur.s': '{{s}} s',
    'usage.dur.m': '{{m}} min',
    'usage.dur.h': '{{h}} h',
    'usage.dur.hm': '{{h}} h {{m}} min',
}

const de: typeof en = {
    'usage.menu': 'Nutzung',
    'usage.title': 'Systemnutzung',
    'usage.description': 'Wer das System nutzt, wann und wie lange – nach Benutzer und Ansicht.',
    'usage.hint': 'Aktive Zeit zählt nur, solange die Seite im Vordergrund ist und genutzt wird; 5 Minuten ohne Eingabe halten sie an.',
    'usage.period': 'Zeitraum',
    'usage.days': '{{count}} Tage',
    'usage.tenant': 'Kunde',
    'usage.allTenants': 'Alle Kunden',
    'usage.staff': 'DistribuAI-Konten anzeigen',
    'usage.kpi.activeUsers': 'Aktive Benutzer',
    'usage.kpi.ofUsers': 'von {{total}}',
    'usage.kpi.activeTime': 'Aktive Zeit',
    'usage.kpi.visits': 'Seitenaufrufe',
    'usage.kpi.logins': 'Anmeldungen',
    'usage.tabs': 'Aufteilung',
    'usage.tab.users': 'Benutzer',
    'usage.tab.views': 'Ansichten',
    'usage.col.user': 'Benutzer',
    'usage.col.email': 'E-Mail',
    'usage.col.role': 'Rolle',
    'usage.col.lastLogin': 'Letzte Anmeldung',
    'usage.col.lastSeen': 'Zuletzt aktiv',
    'usage.col.logins': 'Anmeldungen',
    'usage.col.activeDays': 'Aktive Tage',
    'usage.col.activeTime': 'Aktive Zeit',
    'usage.col.visits': 'Aufrufe',
    'usage.col.topView': 'Meistgenutzte Ansicht',
    'usage.col.view': 'Ansicht',
    'usage.col.users': 'Benutzer',
    'usage.col.avgVisit': 'Ø je Aufruf',
    'usage.col.lastUsed': 'Zuletzt genutzt',
    'usage.col.when': 'Zeit',
    'usage.col.duration': 'Aktive Zeit',
    'usage.col.device': 'Gerät',
    'usage.role.SUPERADMIN': 'Superadmin',
    'usage.role.TENANTADMIN': 'Administrator',
    'usage.staffBadge': 'DistribuAI',
    'usage.disabled': 'Deaktiviert',
    'usage.never': 'Nie',
    'usage.detail.summary': 'Anmeldungen {{logins}} · aktive Tage {{days}} · aktive Zeit {{time}}',
    'usage.detail.views': 'Ansichten',
    'usage.detail.recentVisits': 'Letzte Aufrufe',
    'usage.detail.recentLogins': 'Letzte Anmeldungen',
    'usage.detail.empty': 'Keine Aktivität in diesem Zeitraum.',
    'usage.close': 'Schließen',
    'usage.empty.users': 'Keine Benutzer.',
    'usage.empty.views': 'Keine Aufrufe in diesem Zeitraum.',
    'usage.loading': 'Wird geladen…',
    'usage.loadFailed': 'Die Nutzungsdaten konnten nicht geladen werden.',
    'usage.retry': 'Erneut versuchen',
    'usage.sortAsc': 'Aufsteigend',
    'usage.sortDesc': 'Absteigend',
    'usage.columnMenu': 'Spaltenmenü {{header}}',
    'usage.dur.s': '{{s}} Sek.',
    'usage.dur.m': '{{m}} Min.',
    'usage.dur.h': '{{h}} Std.',
    'usage.dur.hm': '{{h}} Std. {{m}} Min.',
}

const ru: typeof en = {
    'usage.menu': 'Использование',
    'usage.title': 'Использование системы',
    'usage.description': 'Кто пользуется системой, когда и как долго – по пользователям и разделам.',
    'usage.hint': 'Активное время считается, только пока страница открыта и используется; 5 минут без действий останавливают счёт.',
    'usage.period': 'Период',
    'usage.days': '{{count}} дней',
    'usage.tenant': 'Клиент',
    'usage.allTenants': 'Все клиенты',
    'usage.staff': 'Показать учётные записи DistribuAI',
    'usage.kpi.activeUsers': 'Активные пользователи',
    'usage.kpi.ofUsers': 'из {{total}}',
    'usage.kpi.activeTime': 'Активное время',
    'usage.kpi.visits': 'Просмотры',
    'usage.kpi.logins': 'Входы',
    'usage.tabs': 'Разбивка',
    'usage.tab.users': 'Пользователи',
    'usage.tab.views': 'Разделы',
    'usage.col.user': 'Пользователь',
    'usage.col.email': 'Эл. почта',
    'usage.col.role': 'Роль',
    'usage.col.lastLogin': 'Последний вход',
    'usage.col.lastSeen': 'Последняя активность',
    'usage.col.logins': 'Входы',
    'usage.col.activeDays': 'Активных дней',
    'usage.col.activeTime': 'Активное время',
    'usage.col.visits': 'Просмотры',
    'usage.col.topView': 'Чаще всего',
    'usage.col.view': 'Раздел',
    'usage.col.users': 'Пользователи',
    'usage.col.avgVisit': 'В среднем',
    'usage.col.lastUsed': 'Последнее использование',
    'usage.col.when': 'Время',
    'usage.col.duration': 'Активное время',
    'usage.col.device': 'Устройство',
    'usage.role.SUPERADMIN': 'Суперадмин',
    'usage.role.TENANTADMIN': 'Администратор',
    'usage.staffBadge': 'DistribuAI',
    'usage.disabled': 'Отключён',
    'usage.never': 'Никогда',
    'usage.detail.summary': 'Входы {{logins}} · активных дней {{days}} · активное время {{time}}',
    'usage.detail.views': 'Разделы',
    'usage.detail.recentVisits': 'Последние просмотры',
    'usage.detail.recentLogins': 'Последние входы',
    'usage.detail.empty': 'Нет активности за этот период.',
    'usage.close': 'Закрыть',
    'usage.empty.users': 'Нет пользователей.',
    'usage.empty.views': 'Нет просмотров за этот период.',
    'usage.loading': 'Загрузка…',
    'usage.loadFailed': 'Не удалось загрузить данные.',
    'usage.retry': 'Повторить',
    'usage.sortAsc': 'По возрастанию',
    'usage.sortDesc': 'По убыванию',
    'usage.columnMenu': 'Меню столбца {{header}}',
    'usage.dur.s': '{{s}} с',
    'usage.dur.m': '{{m}} мин',
    'usage.dur.h': '{{h}} ч',
    'usage.dur.hm': '{{h}} ч {{m}} мин',
}

for (const [language, strings] of Object.entries({ en, et, de, ru })) {
    i18n.addResourceBundle(language, 'translation', strings, true, false)
}
